"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.extract = extract;
exports.isTar = isTar;
exports.isZip = isZip;
exports.isArchive = isArchive;
const fs_1 = require("fs");
const path_1 = require("path");
const uuid_1 = require("uuid");
const common_1 = require("./common");
const debug_1 = require("./debug");
const pMap = require('p-map');
const AdmZip = require('adm-zip');
const tar = require('tar');
const { mkdir, rename } = fs_1.promises;
const zipFormats = ['.zip', '.zipx'];
const tarFormats = ['.tar', '.gz', '.tgz'];
async function handleExtraction(path, temporaryDir, keepArchive, childArchiveHandler) {
    const extractionSource = keepArchive
        ? path
        : (0, path_1.join)(temporaryDir, common_1.DECOMPRESSING_IGNORE_DIR, `${(0, uuid_1.v4)()}-${(0, path_1.basename)(path)}`);
    if (!keepArchive) {
        await mkdir((0, path_1.dirname)(extractionSource), { recursive: true });
        await rename(path, extractionSource);
    }
    const extractionTarget = (0, path_1.join)(temporaryDir, common_1.DECOMPRESSING_WORKSPACE_DIR, path.includes(temporaryDir)
        ? (0, path_1.relative)((0, path_1.join)(temporaryDir, common_1.DECOMPRESSING_WORKSPACE_DIR), path)
        : (0, path_1.basename)(path));
    await mkdir(extractionTarget, { recursive: true });
    if (isTar(extractionSource)) {
        await tar.x({
            file: extractionSource,
            cwd: extractionTarget,
            sync: true,
            onentry: (entry) => {
                const childAbsolutePath = (0, path_1.join)(extractionTarget, entry.path);
                if (isArchive(childAbsolutePath)) {
                    childArchiveHandler(childAbsolutePath);
                }
            },
        });
    }
    else if (isZip(extractionSource)) {
        const zip = new AdmZip(extractionSource);
        await pMap(zip.getEntries(), (entry) => {
            const childAbsolutePath = (0, path_1.join)(extractionTarget, entry.entryName);
            zip.extractEntryTo(entry.entryName, extractionTarget, true, true);
            if (isArchive(childAbsolutePath)) {
                childArchiveHandler(childAbsolutePath);
            }
        }, { concurrency: common_1.DECOMPRESSING_CONCURRENCY_LEVEL });
    }
}
async function extract(archives, temporaryDir, depthLimit, depth = 0) {
    if (depth >= depthLimit) {
        return;
    }
    const childArchives = [];
    for (const archive of archives) {
        try {
            const keepArchive = 0 === depth;
            await handleExtraction(archive, temporaryDir, keepArchive, (childArchive) => childArchives.push(childArchive));
        }
        catch (err) {
            (0, debug_1.debug)(`Could not extract archive: ${archive} ${err}`);
        }
    }
    if (childArchives.length > 0) {
        await extract(childArchives, temporaryDir, depthLimit, depth + 1);
    }
}
function isTar(path) {
    return tarFormats.includes((0, path_1.extname)(path));
}
function isZip(path) {
    return zipFormats.includes((0, path_1.extname)(path));
}
function isArchive(path) {
    return isTar(path) || isZip(path);
}
//# sourceMappingURL=extract.js.map